import React, { useEffect, useRef, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label, { DisplayLabel } from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Float from "../ui/Float";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { arrayToObject, bm_date, bm_time, drawNote, drawPOSStatus, drawPrice, getEnumLabel, pluralize } from "../utils/Utils";
import { useTabs } from "../hooks/useTabs";
import { ROUTES } from "../utils/Routes";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import CustomersController from "../controllers/CustomersController";
import { createScreen } from "../hooks/createScreen";
import { getSignal } from "../App";
import { CUSTOMER } from "../utils/Struct";
import { pos_editHeader } from "../controllers/POSController";
import POSHeaderExtras from "./POSHeaderExtras";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import FocusWrap from "../hooks/FocusWrap";
import CustomerAddress from "./CustomerAddress";
import SetupTaxCodes from "../popups/SetupTaxCodes";
import { ENUMS } from "../utils/Enums";
import EnumField from "../ui/EnumField";
import dayjs from "dayjs";

export default function POSDetails(props) {

    const { controller = "", employee = "", items_total = 0, selected = {}, setSelected = () => { }, items = [], setItems = () => { }, selectedItem = {}, setSelectedItem = () => { }, state = {}, setState = () => { }, cancelEdit = () => { } } = props;



    useEffect(() => {


        update(
            {
                "customer_bill_to": selected?.customer_bill_to,
                "customer_ship_to": selected?.customer_ship_to,
                "customer_bill_to_select": selected?.customer_bill_to?.name,
                "customer_ship_to_select": selected?.address?.name,
                "customer": selected?.customer_ship_to?.name,
                "tax_code": selected?.tax_code,
                "purchase_order": selected?.purchase_order,
                "notes": selected?.notes,
                "ship_via": selected?.ship_via,
                "terms": selected?.terms,
                "per": selected?.per,
                "cancel_date": selected?.cancel_date,
                "combine": selected?.combine,
                "partial": selected?.partial,
                "hold_till": selected?.hold_till,
                "max_value": selected?.max_value,

            }
        )

        const skip = (state?.edit && (!selected?.customer_ship_to?.ship_to));

        updateSkip(
            {
                ["customer_bill_to_select"]: skip,
                ["customer_ship_to_select"]: skip,
                ["tax_code"]: skip,
                ["purchase_order"]: skip,
                ["notes"]: skip,
                ["ship_via"]: skip,
                ["terms"]: skip,
            }
        )

    }, [selected])



    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }


    const editAddress = () => {

        blurField();
        window.bm_state.value = ROUTES.CUSTOMER.ADDRESS;

        createModal({
            title: "Customer Shipping Addresses",
            component: <CustomerAddress customer={getVal("customer_ship_to")} controller={controller} route={ROUTES.CUSTOMER.ADDRESS} />,
            closable: true,
            callback: (e) => {
                if (e) {
                    // do something with the address

                    update({ "address": e, "customer_ship_to_select": e?.name });
                }
                focusField()
                window.bm_state.value = ROUTES.POS.CUSTOMER;
            }
        })
    }


    const editHeaderExtras = (e) => {

        if (!e) {
            showError({ error: "A PO# is needed to access the PO header." });
            return;
        }
        blurField();
        window.bm_state.value = ROUTES.POS.CUSTOMER_EXTRAS;

        createModal({
            title: "POS Header",
            component: <POSHeaderExtras controller={controller} selected={arrayToObject(tabs)} route={ROUTES.POS.CUSTOMER_EXTRAS} />,
            closable: true,
            callback: (e) => {
                if (e) {

                    console.log(tabs)
                    //update(e)
                    update({
                        ["per"]: "This should change",

                    })

                    setTimeout(() => {
                        console.log(tabs)
                    }, 1000)
                    //const _upd = arrayToObject(e);
                    //console.log(_upd)

                }
                focusField()
                window.bm_state.value = ROUTES.POS.CUSTOMER;

            }
        })
    }


    const selectCustomer = (_search = "", type = "ship_to") => {
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        blurField();
        createScreen({
            signal: getSignal(),
            component: <CustomersController controller={controller} is_modal search={_search} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = ROUTES.POS.CUSTOMER;
                if (_obj) {

                    if (type === "bill_to") {

                        update({
                            ["customer_bill_to"]: _obj,
                            ["customer_bill_to_select"]: _obj?.name,
                        })
                    }
                    if (type === "ship_to") {




                        update({
                            ["customer_ship_to"]: _obj,
                            ["customer"]: _obj?.name
                        })

                        updateSkip(
                            {
                                ["customer_bill_to_select"]: false,
                                ["customer_ship_to_select"]: false,
                                ["tax_code"]: false,
                                ["purchase_order"]: false,
                                ["notes"]: false,
                                ["ship_via"]: false,
                                ["terms"]: false,
                            }
                        )
                    }

                }
                refs.current["customer"].focus();
            }
        });
    }


    const init_new = (state?.edit && (!selected?.customer_ship_to?.ship_to));

    const defaultTabs = [
        { key: "customer_bill_to", value: selected?.customer_bill_to, skip: true },
        { key: "customer_ship_to", value: selected?.customer_ship_to, skip: true },
        { key: "customer_bill_to_select", value: selected?.customer_bill_to?.name || "", skip: init_new },
        { key: "customer_ship_to_select", value: "", skip: init_new },
        { key: "customer", value: selected?.customer_ship_to?.name || "" },
        { key: "tax_code", value: selected?.tax_code || "", skip: init_new }, // 1 2 B 3 blank
        { key: "purchase_order", value: selected?.purchase_order || "", skip: init_new },
        { key: "notes", value: selected?.notes, skip: init_new },
        { key: "ship_via", value: selected?.ship_via, skip: init_new },
        { key: "terms", value: selected?.terms, skip: init_new },

        { key: "per", value: selected?.per, skip: true },
        { key: "cancel_date", value: selected?.cancel_date, skip: true },
        { key: "combine", value: selected?.combine, skip: true },
        { key: "partial", value: selected?.partial, skip: true },
        { key: "hold_till", value: selected?.hold_till, skip: true },
        { key: "max_value", value: selected?.hold_till, skip: true },

        { key: "address", value: selected?.address, skip: true },

    ]

    const {
        tabs, setTabs, index, setIndex, update, updateSkip, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "customer");


    const fields_enabled = (window.bm_state.value === ROUTES.POS.CUSTOMER)
    const hasShipTo = !!getVal("customer_ship_to")?.ship_to;
    const editing_new = state?.edit && !hasShipTo;
    const editing_existing = state?.edit && fields_enabled && hasShipTo;


    const switchToTransaction = () => {
        setState({ ...state, "view": "items" })
        window.bm_state.value = ROUTES.POS.EDIT;
    }

    const switchToCustomer = () => {
        setState({ ...state, "view": "customer" })
        window.bm_state.value = ROUTES.POS.CUSTOMER;
    }




    const updateTransaction = () => {

        let _header = { ...selected };

        console.log("UPDATE TRANSACTION", selected)

        _header.customer_bill_to = getVal("customer_bill_to");
        _header.customer_ship_to = getVal("customer_ship_to");
        _header.purchase_order = getVal("purchase_order");
        _header.tax_code = getVal("tax_code");
        _header.notes = getVal("notes");
        _header.ship_via = getVal("ship_via");
        _header.terms = getVal("terms");

        _header.per = getVal("per");
        _header.cancel_date = getVal("cancel_date");
        _header.combine = parseInt(getVal("combine") || 0);
        _header.partial = parseInt(getVal("partial")) || 0;
        _header.hold_till = parseInt(getVal("hold_till")) || 0;
        _header.max_value = getVal("max_value");
        _header.address = getVal("address") || null;


        if (!selected?.invoice) {
            // New
            blurField();
            setSelected(_header);
            switchToTransaction();
        } else {
            pos_editHeader({ header: _header, employee: employee }, (_s, _r) => {
                if (_s) {
                    setSelected(_r?.header || _header);
                    blurField();
                    switchToTransaction();
                } else {
                    showError(_r)
                }
            })
        }
    }




    useEffect(() => {

        if (window.bm_state.value === ROUTES.POS.CUSTOMER && state.edit) {
            if (refs?.current[index]) refs.current[index].focus();
        }

        const actions = [
            {
                key: KBD.ESCAPE, action: () => {

                    update({
                        customer_bill_to: selected?.customer_bill_to,
                        customer_ship_to: selected?.customer_ship_to,
                        customer_bill_to_select: selected?.customer_bill_to?.name || "",
                        customer_ship_to_select: selected?.address?.name || "",
                        customer: selected?.customer_ship_to?.name || "",
                        tax_code: selected?.tax_code || "",
                        purchase_order: selected?.purchase_order || "",
                        notes: selected?.notes || "",
                        ship_via: selected?.ship_via || "",
                        terms: selected?.terms || "",
                        per: selected?.per || "",
                        cancel_date: selected?.cancel_date || "",
                        combine: selected?.combine || "",
                        partial: selected?.partial || "",
                        hold_till: selected?.hold_till || "",
                        max_value: selected?.max_value || "",
                        address: selected?.address || null,
                    });

                    blurField();
                    switchToTransaction()
                }
            },
            {
                key: KBD.PAGE_DOWN, action: () => {

                    updateTransaction()
                }
            },

            {
                key: KBD.ARROW_UP, action: () => {

                    if (editing_new) {
                        return;
                    }
                    prev();
                }
            },

            {
                key: KBD.ARROW_DOWN, action: () => {
                    console.log("Arrow down")
                    if (index === "customer" && !hasShipTo) {
                        blurField()
                        switchToTransaction()
                    } else {
                        next()
                    }
                }
            },
        ]
        const cleanup = listen(controller, ROUTES.POS.CUSTOMER, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]);
        return cleanup;

    }, [window.bm_state.value, index, editing_new, tabs])


    const drawBill = () => {
        const c = selected?.customer_bill_to || {};
        const {
            name = "",
            bill_to = "",
        } = c;
        return (
            <>
                <Space size={10}>
                    <Label width={35}>Bill</Label>
                    <Input {...editProps("customer_bill_to_select")} onEnter={(e) => selectCustomer(e, "bill_to")} edit={editing_existing} className={(editing_existing) ? "" : "dim"} style={{ "pointerEvents": (fields_enabled) ? "auto" : "none" }} grow />
                </Space>

                <div className="shim" />
            </>
        )
    }


    const drawShip = () => {
        const shipTo = getVal("customer_ship_to") || {};
        const address = getVal("address") || shipTo || {};

        const {
            name = "",
            address_1 = "",
            address_2 = "",
            city = "",
            province = "",
            postal_code = "",
            country = "",
        } = address;

        return (
            <>
                <div style={{ height: "75px" }}>
                    <Space style={{ alignItems: "start" }} size={10}>
                        <Label width={35}>Ship</Label>

                        <Input
                            grow
                            {...editProps("customer_ship_to_select")}
                            value={getVal("customer_ship_to_select")}
                            onDoubleClick={() => editAddress()}
                            onPageUp={() => editAddress()}
                            onEnter={() => editAddress()}
                            edit={editing_existing}
                            className={editing_existing ? "" : "dim"}
                            style={{ pointerEvents: fields_enabled ? "auto" : "none" }}
                        />


                    </Space>
                    <div className="shim" />
                    <Space>
                        <Label width={40}>&nbsp;</Label>
                        <DisplayLabel className="text-yellow" style={{ textAlign: "left" }} >
                            <div className="shim" style={{ height: "1px" }} />
                            <div>{address_1} {address_2}</div>
                            <div>{city && <>{city}, </>}{province} {postal_code} {country}</div>
                        </DisplayLabel>
                    </Space>
                </div>

                <div className="shim" />
            </>
        );
    };

    const drawExtra = () => {
        const c = selected || {};
        const {
            ship_via = "",
            customer_ship_to = null
        } = c;

        const {
            ship_to = "",
            communication_preference = ""
        } = customer_ship_to || {}



        return (
            <>
                <Float><Label>Bill ID</Label>
                    <DisplayLabel>&nbsp;{c?.customer_bill_to?.ship_to || ""}</DisplayLabel>
                </Float>
                <div className="shim" />
                <Float><Label>Ship ID</Label>
                    <DisplayLabel>&nbsp;{ship_to}</DisplayLabel>
                </Float>
                <div className="shim" />
                <Float><Label>Comm Pref</Label>
                    <DisplayLabel>&nbsp;{getEnumLabel(ENUMS.COMM_PREF, communication_preference)}</DisplayLabel>
                </Float>
                <div className="shim" />
                <Float><Label>Tax Code</Label>
                    <Input maxLength={1} width={35} {...editProps("tax_code")} onPageUp={() => drawTaxCodes()} className={(fields_enabled) ? "" : "dim"} style={{ "pointerEvents": (fields_enabled) ? "auto" : "none" }} uppercase chars={["1", "2", "B", "3"]} />
                </Float>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Float><Label>&nbsp;</Label><DisplayLabel >&nbsp;</DisplayLabel></Float>
            </>
        )
    }


    const drawVia = () => {
        const c = selected || {};
        const {
            ship_via = "",
            terms = ""
        } = c;

        return (
            <>
                <Float><Label>Via</Label>
                    <Input {...editProps("ship_via")} width={105} edit={editing_existing} className={(editing_existing) ? "text-yellow" : "dim"} style={{ "pointerEvents": (editing_existing) ? "auto" : "none" }} />
                </Float>
                <div className="shim" />
                <Float><Label>Terms</Label>
                    <Input {...editProps("terms")} width={105} edit={editing_existing} className={(editing_existing) ? "" : "dim"} style={{ "pointerEvents": (editing_existing) ? "auto" : "none" }} />
                </Float>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Float><Label>&nbsp;</Label><DisplayLabel >&nbsp;</DisplayLabel></Float>
            </>
        )
    }


    const drawTaxes = (_taxes = [], inc) => {

        if (_taxes.length >= inc) {

            const {
                amount = 0,
                item_amount = 0,
                name = "",
                code = "",
                rate = 0,
            } = _taxes[inc - 1];

            return (<Float><Label>{code} {name}</Label><DisplayLabel >{drawPrice(amount, true)}</DisplayLabel></Float>)
        } else {
            return (<Float><Label>&nbsp;</Label><DisplayLabel >&nbsp;</DisplayLabel></Float>)
        }

    }
    const drawCalculatedTotals = () => {

        const c = selected?.calculated_totals || {};
        const {
            sub_total = 0,
            item_total = 0,
            tax_total = 0,
            total = 0,
            taxes = []
        } = c;




        return (
            <>
                <div style={{ "height": "5px" }} />
                <Float><Label>&nbsp;</Label>
                    <DisplayLabel>{items_total} {(items_total === 1) ? <>item</> : <>items</>}</DisplayLabel>
                </Float>
                <Float><Label>Sub</Label><DisplayLabel >{drawPrice(sub_total, true)}</DisplayLabel></Float>
                {drawTaxes(taxes, 1)}
                {drawTaxes(taxes, 2)}
                {drawTaxes(taxes, 3)}
                <div style={{ "height": "13px" }} />
                <Input warning grow value={<Float><small>Total</small><div>{drawPrice(total, true)}</div></Float>} />
            </>
        )

    }

    const drawTaxCodes = () => {
        blurField();
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES;
        createModal({
            component: <SetupTaxCodes returnObj={true} controller={controller} route={ROUTES.GLOBAL.SETUP_TAXCODES} />, closable: true, title: "Select Tax Code", callback: (e) => {
                window.bm_state.value = origin;
                focusField();
                update("tax_code", e?.customer_code || "");
            }
        })
    }


    const coverRef = useRef(null);
    const drawImage = () => {
        // If no main, load secondary, if no secondary load placeholder.
        const primary = `https://bookmanager.com/i/bkmngr_cover/isbn/${selectedItem?.stock_data?.primary_code || ""}`;
        const secondary = selectedItem?.stock_data?.secondary_code ? `https://bookmanager.com/i/bkmngr_cover/isbn/${selectedItem?.stock_data?.secondary_code || ""}` : null;
        const placeholder = "https://bookmanager.com/i/nocover-120.png";

        return (
            <div
                key={selectedItem?.stock_data?.primary_code}
                ref={coverRef}
                className="img-contain fade"
                id="cover-div"
                style={{
                    height: "235px",
                    backgroundPosition: "center top",
                    backgroundSize: "contain",
                    backgroundImage: `url('${primary}')`,

                }}
            >
                <img
                    src={primary}
                    alt="Cover Image"
                    style={{ visibility: "hidden" }}
                    onError={(e) => {
                        const img = e.currentTarget;
                        if (img.src === primary && secondary) {
                            img.src = secondary;
                            coverRef.current.style.backgroundImage = `url('${secondary}')`;
                            return;
                        }
                        img.src = placeholder;
                        coverRef.current.style.backgroundImage = `url('${placeholder}')`;
                    }}
                />
            </div>
        );
    };


    const drawAccount = () => {
        const c = getVal("customer_bill_to") || {};
        const {
            name = "",
            address_1 = "",
            address_2 = "",
            city = "",
            province = "",
            postal_code = "",
            country = "",
            email = "",
            account_number = "",
            communication_preference = "",
            tax_group_code = "",
        } = c;


        return (
            <>
                <div style={{ "height": "75px" }}><Space style={{ "alignItems": "start" }} size={10}>
                    <Label width={37}>Acct</Label>
                    <Space size={18} style={{ "width": "100%", "alignItems": "flex-start" }}>
                        <div style={{ "width": "100%", display: "flex", flexDirection: "column" }}>
                            <Input {...editProps("customer")} edit onEnter={(e) => selectCustomer(e)} className={(fields_enabled) ? "" : "dim"} style={{ "pointerEvents": (fields_enabled) ? "auto" : "none" }} grow />
                            <div className="shim" />
                            <DisplayLabel style={{ "textAlign": "left", "paddingLeft": "2px" }}>
                                <div className="shim" style={{ "height": "3px" }} />
                                <div>{address_1} {address_2}</div>
                                <div>{(city && <>{city}, </>)}{province} {postal_code} {country}</div>
                                {/* <div>{email}</div> */}
                            </DisplayLabel>
                        </div>

                    </Space>
                </Space>
                </div>
                <div className="shim" /></>
        )


        return (
            <div>
                <div style={{ "height": "88px" }}>
                    <Space style={{ "alignItems": "start" }} size={10}>
                        <Label width={35}>Acct</Label>

                        <div style={{ "flexGrow": "1", "display": "flex" }}>
                            <Input {...editProps("customer")} edit onEnter={(e) => selectCustomer(e)} className={(fields_enabled) ? "" : "dim"} style={{ "pointerEvents": (fields_enabled) ? "auto" : "none" }} grow />
                            {/* <DisplayLabel style={{ "textAlign": "left" }} width={510}>
                           
                            <div>{address_1} {address_2}</div>
                            <div>{(city && <>{city}, </>)}{province} {postal_code} {country}</div>
                            <div>{email}</div>
                        </DisplayLabel> */}
                        </div>



                        <div>
                            <Space><Label style={{ "textAlign": "left" }} width={40}>Acct#</Label><DisplayLabel width={95}>{account_number}&nbsp;</DisplayLabel></Space>
                            <Space><Label style={{ "textAlign": "left" }} width={90}>Pref</Label><DisplayLabel className="text-yellow" width={45}>{communication_preference}&nbsp;</DisplayLabel></Space>
                            <Space><Label style={{ "textAlign": "left" }} width={90}>Tax Code</Label><DisplayLabel width={45}>{tax_group_code}&nbsp;</DisplayLabel></Space>
                        </div>
                    </Space>
                </div>
                <Space><Label width={42}></Label><Divider /></Space>
            </div>
        )
    }

    const drawPO = () => {

        const c = selected || {};
        const {
            purchase_order = ""
        } = c;

        return (
            <Space style={{ "alignItems": "start" }} size={10}>
                <Label width={35}>PO#</Label>
                <div style={{ "flexGrow": "1" }}>
                    <Input {...editProps("purchase_order")} uppercase maxLength={10} width={140} edit={editing_existing} onPageUp={(e) => editHeaderExtras(e)} className={(editing_existing) ? "" : "dim"} style={{ "pointerEvents": (editing_existing) ? "auto" : "none" }} />
                </div>
            </Space>
        )

    }

    const drawNote = () => {
        const note = selected?.notes || "";
        return (
            <Space size={10}>
                <Label width={35}>Note</Label><DisplayLabel><em>{note} &nbsp;</em></DisplayLabel>
            </Space>
        )
    }

    

    const drawStage = (_stage) => {
        switch (_stage) {
            case "Held":
                let _sfx = "";
                if(props?.customer_other_helds){
                    _sfx = " +" + props?.customer_other_helds;
                }

                return (<span style={{ "color": "var(--text-light-red)" }}>Held{_sfx}</span>)
            case "Quote":
                return (<span style={{ "color": "var(--text-light-red)" }}>Held</span>)
            default:
                return <>{_stage}</>;
        }
    }

    const drawWarn = (_stage) => {

        let _msg = "";
        if(_stage === "Online"){
            _msg = "Online";
        }

        if(!_msg){
            return(<></>)
        }

        return(<Float><Input cell className="error" value={_msg} /></Float>)
    }

    const drawGroup = () => {

        const c = selected || {};
        const {
            date = "",
            invoice = "",
            points_total = 0,
            points_earned = 0,
            group = "",
            clerk_code = "",
            stage = "",
            locked = "",
        } = c;

        const pts = c?.customer_ship_to?.frequent_buyer_point;
        return (
            <>
                <Float>
                    <div><Space><Label>Group</Label><DisplayLabel>{group}&nbsp;</DisplayLabel></Space></div>
                    <div><Space><Label>Clerk</Label><DisplayLabel>{clerk_code}&nbsp;</DisplayLabel></Space></div>
                </Float>
                <Float><Label>Date</Label><DisplayLabel >{bm_date(date / 1000)}&nbsp;</DisplayLabel></Float>
                <Float><Label>Time</Label><DisplayLabel >{dayjs(date).format("h:MM a")}</DisplayLabel></Float>
                <Float><Label>Inv#</Label><DisplayLabel >{invoice}&nbsp;</DisplayLabel></Float>
                <Float><Label>Status</Label><DisplayLabel >{drawStage(stage)}&nbsp;</DisplayLabel></Float>

                <div style={{ "height": "25px" }}>
                  {(locked && locked !== " ") ? <Input style={{"textAlign" : "center"}} warning grow value={locked} /> : ""}
                </div>
                <div style={{ "height": "25px" }} />
                <Float><Label>{(pts ? "FB Bal" : "")}</Label><DisplayLabel >{(pts) ? pts : ""}&nbsp;</DisplayLabel></Float>
                <div style={{ "height": "40px" }} />
                {/* <Float><Label>Profit Margin</Label><DisplayLabel>?&nbsp;</DisplayLabel></Float>
                <Float><Label>Points Total</Label><Input right width={65} medium style={{ "backgroundColor": "#E74856" }} value={points_total} /></Float>
                <Float><Label>Points Earn</Label><DisplayLabel >{points_earned}&nbsp;</DisplayLabel></Float> */}

                <Float><Label></Label><Space><Label>PM</Label><DisplayLabel >??</DisplayLabel></Space></Float>
            </>
        )

    }


    const drawMessage = () => {
        switch (index) {
            case "customer_bill_to_select": return <>Biller name, phone or acct# [PgUp] to view</>;
            case "customer_ship_to_select": return <>[PgUp] to add/view/edit the alternate shipping address, blank to remove it</>;
            case "customer": return <>Name, phone or acct# [PgUp] to view</>
            case "tax_code": return <>Blank for default treatment [PgUp] to view Tax Tables</>
            case "purchase_order": return <>Customer's PO# [PgUp] to access PO Header</>;
            case "notes": return <>Use for Notes. This line will appear on the invoice</>;
            case "ship_via": return <></>
            case "terms": return <></>
            default:
                return <>...</>
        }
    }



    return (
        <FocusWrap message={(drawMessage() && <Status type="active"><InfoIcon />{drawMessage()}</Status>)} style={{ "height": "auto" }} active={state.edit && state.view === "customer"}>

            <div onClick={() => {
                if (state?.edit && window.bm_state.value === ROUTES.POS.EDIT) {
                    switchToCustomer();
                }
            }} className="pos-card">
                <div className="shim" />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'row', gap: "20px" }}>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            flex: "1 1 760px",
                            minWidth: "560px",
                        }}
                    >

                        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                            <div style={{ flex: "1 1 320px", minWidth: "370px" }}>
                                {drawBill()}
                                {drawShip()}
                                {drawAccount()}
                                {drawPO()}
                            </div>

                            <div style={{ height: "210px", backgroundColor: "var(--border-secondary)", width: "1px" }} />

                            <div style={{ minWidth: "170px" }}>
                                {drawExtra()}
                            </div>
                        </div>
                        <div className="shim" />
                        <Space size={10} style={{ width: "100%", marginTop: "0px" }}>
                            <Label width={35}>Note</Label>
                            <Input
                                {...editProps("notes")}
                                edit={editing_existing}
                                className={editing_existing ? "" : "dim"}
                                style={{
                                    pointerEvents: editing_existing ? "auto" : "none",
                                    flex: 1,
                                }}
                                width={450}
                            />
                        </Space>
                    </div>
                    <div style={{ "height": "240px", "backgroundColor": "var(--border-secondary)", "width": '1px' }}></div>
                    <div style={{ minWidth: "160px" }}>
                        {drawVia()}
                        {drawCalculatedTotals()}
                    </div>
                    <div style={{ "height": "240px", "backgroundColor": "var(--border-secondary)", "width": '1px' }}></div>
                    <div style={{ flex: "1 1 180px", minWidth: "180px" }}>
                        {drawGroup()}
                    </div>
                    <div style={{ "height": "240px", "backgroundColor": "var(--border-secondary)", "width": '1px' }}></div>
                    <div style={{ flex: "1 5 150px", minWidth: "0px" }}>
                        <div className="shim" style={{ "height": "7px" }} />
                        {drawImage()}

                    </div>
                </div>


            </div>
        </FocusWrap>
    )
}